import React from 'react';
import _merge from 'lodash/merge';

import { getContext, isAnimationDisabled } from 'common';
import CircularProgressIndicatorBackgroundCircle from './CircularProgressIndicatorBackgroundCircle';
import CircularProgressIndicatorProgressCircle from './CircularProgressIndicatorProgressCircle';
import Styled, { CIRCLE_WIDTH } from './styles';

interface CircularProgressIndicatorContextInterface {
  circleSize?: number
}

const CircularProgressIndicatorContext = React.createContext<CircularProgressIndicatorContextInterface | null>({});

export interface CircularProgressIndicatorDeterminateProps extends React.ComponentPropsWithRef<'div'> {
  /** Size of the circle in pixels. */
  circleSize?: number;
  /** How much progress is complete. The progress value has to be between 0 and 100. Pass rounded progress value */
  progress: number;
  /** Renders the Text, use "CircularProgressIndicatorInnerText" */
  renderInnerText?: React.ReactNode;
  /** Renders the Text, use "CircularProgressIndicatorOuterText" */
  renderOuterText?: React.ReactNode;
  /** If true, disable all motion animation for this component.  This property will override any global disableAnimation setting. */
  disableAnimation?: boolean;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/** CircularProgressIndicatorDeterminate,
 * all other props than `circleSize`, `progress`, `renderInnerText`, `renderOuterText` will be provided to the root DOM element */
const CircularProgressIndicatorDeterminate = React.forwardRef<HTMLDivElement, CircularProgressIndicatorDeterminateProps>((props: CircularProgressIndicatorDeterminateProps, ref) => getContext(({ RTL, theme, disableAnimation }) => {
  const {
    circleSize,
    progress,
    renderInnerText,
    renderOuterText,
    theme: themeProp,
    disableAnimation: propsdisableAnimation,
    ...otherProps
  } = props;

  const resolvedTheme = _merge({}, theme ? theme.CIRCULAR_PROGRESS_DETERMINATE : {}, themeProp);

  return (
    <div {...otherProps} ref={ref}>
      <CircularProgressIndicatorContext.Provider
        value={{
          circleSize
        }}
      >
        <Styled.Svg size={circleSize} rtl={RTL} >
          <CircularProgressIndicatorBackgroundCircle theme={resolvedTheme} />
          <CircularProgressIndicatorProgressCircle disableAnimation={isAnimationDisabled(propsdisableAnimation, disableAnimation)} progress={progress} theme={resolvedTheme} />
          {(circleSize > CIRCLE_WIDTH) ? renderInnerText : null}
        </Styled.Svg>
        {renderOuterText}
      </CircularProgressIndicatorContext.Provider>
    </div>
  );
}));

CircularProgressIndicatorDeterminate.defaultProps = {
  circleSize: 20,
  renderOuterText: undefined,
  renderInnerText: undefined,
  disableAnimation: undefined,
  theme: {},
};

CircularProgressIndicatorDeterminate.displayName = 'CircularProgressIndicatorDeterminate';

export {
  CircularProgressIndicatorDeterminate as default,
  CircularProgressIndicatorContext
};

